import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-about-statistics',
  imports: [TranslatePipe],
  templateUrl: './about-statistics.html',
  styleUrl: './about-statistics.scss',
})
export class AboutStatistics {}
